/**!  
 * Dimokratiki 2021
 * Version: 1.0.0 
 * Homepage scripts
 * @since 1.0.0.
 * 
 **/

import { DomReady } from "./scripts.js";

DomReady( function() {

	var heroSlider = document.querySelector('.hero-main');

	if( heroSlider ) {
		heroSlider.classList.add("active");
	}

	// Sticky Navigation
	const stickyElm = document.querySelector('#navigation');

	const observer = new IntersectionObserver(
		([e]) => e.target.classList.toggle('sticked', e.intersectionRatio < 1), {
			rootMargin: '-1px 0px 0px 0px',
			threshold: [1],
		}
	);

	observer.observe(stickyElm);

});


// import Swiper JS
// import Swiper from './swiper.js';
// import Swiper from 'swiper';
import { Swiper, Thumbs, Autoplay, Navigation } from "swiper";
Swiper.use([Thumbs, Autoplay, Navigation]);
// import 'swiper/swiper-bundle.css';
// import Swiper from 'https://unpkg.com/swiper/swiper-bundle.esm.browser.min.js';

const heroThumbs = new Swiper('.slide-thumbs', {
	direction: 'vertical',
	spaceBetween: 24,
	slidesPerView: 5,
	freeMode: true,
	loopedSlides: 5, //looped slides should be the same
	watchSlidesVisibility: true
	// watchSlidesProgress: true
});

const heroSlider = new Swiper(".slide-main", {
	preloadImages: true,
	updateOnImagesReady: true,
	spaceBetween: 0,
	grabCursor: true,
	preventClicks: false,
	speed: 1400,
	loop: true,
	loopedSlides: 5, //looped slides should be the same
	autoplay: {
		delay: 10000,
		// disableOnInteraction: true
	},
	navigation: {
		nextEl: ".swiper-button-next"
	},
	hideOnClick: true,
	thumbs: {
		swiper: heroThumbs,
	}
});

const interviews = new Swiper(".interviews-slider", {
	preloadImages: true,
	updateOnImagesReady: true,
	slidesPerView: 4,
	spaceBetween: 16,
	speed: 800,
	loop: true,
	loopedSlides: 8,
	autoplay: { delay: 8000 },
	navigation: {
		nextEl: ".swiper-button-next",
	},

	breakpoints: {
		320: {
			slidesPerView: 1,
			spaceBetween: 16,
		},
		640: {
			slidesPerView: 2,
			spaceBetween: 24,
		},
		760: {
			slidesPerView: 2,
			spaceBetween: 24,
		},
		1024: {
			slidesPerView: 3,
			spaceBetween: 24,
		},
		1300: {
			slidesPerView: 4,
			spaceBetween: 32,
		},
	},
});

const apopseis = new Swiper(".apopseis-slider", {
	preloadImages: true,
	updateOnImagesReady: true,
	slidesPerView: 3,
	spaceBetween: 16,
	speed: 800,
	loop: true,
	loopedSlides: 8,
	autoplay: { delay: 14000 },
	navigation: {
		nextEl: ".swiper-button-next",
	},

	breakpoints: {
		640: {
			slidesPerView: 1,
			spaceBetween: 24,
		},
		768: {
			slidesPerView: 2,
			spaceBetween: 24,
		},
		1380: {
			slidesPerView: 3,
			spaceBetween: 24,
		},

	},
});

// heroSlider;

// console.log('homepage.js loaded!');

//quiet